import React from 'react';
import styled from 'styled-components';

import Wrapper from './wrapper';
import Icon from './icon';
import SelectElement from './select';
import spacer from '../spacer';

const Select = ({ className, ...other }) => (
  <Wrapper className={className}>
    <Icon />
    <SelectElement {...other} />
  </Wrapper>
);

export default styled(Select)`
 ${({ $noSpacer }) => !$noSpacer && spacer}
`;
